module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/environment/environment.component.scss
// module id = ./src/app/pages/environment/environment.component.scss
// module chunks = main